import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../ui/ColorCircle.vue.js';
import __vue_component__$1 from '../../ui/ImageComponent.vue.js';

var script = defineComponent({
    name: 'SupplyLabel',
    components: {
        ColorCircle: __vue_component__,
        ImageComponent: __vue_component__$1,
    },
    props: {
        /**
         * If passed, displays a serial number below the supply name, or the last
         * 4 digits on the same line is `shortSerial` is true.
         */
        serial: {
            type: String,
            default: null,
        },
        shortSerial: Boolean,
        supply: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const label = computed(() => {
            const { name } = props.supply;
            if (props.shortSerial && props.serial) {
                return `${name} - ends in ${props.serial.slice(-4)}`;
            }
            return name;
        });
        const color = computed(() => props.supply.color);
        const imageSrc = computed(() => props.supply.imageColor);
        return {
            color,
            imageSrc,
            label,
        };
    },
});

export { script as default };
